import React from 'react';

const Features = () => {
    return (
        <div id="features" className="mb-4">
            <div className="text-center">
                <h3 style={{ color: 'tomato' }}>OUR FEATURES</h3>
                <h1>OUR EXCLUSIVE FEATURES</h1>
            </div>
            <div className="row -md m-4 g-4">
                <div className="col-md-6 p-3 ">
                    <h2>ONLINE BOOKING</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit distinctio perferendis dolorum culpa cum labore, adipisci provident, quisquam hic sequi error necessitatibus tenetur. Exercitationem illum eaque neque nesciunt ipsa ad.</p>
                    <button className="btn text-success">Learn more</button>
                </div>
                <div className="col-md-6 p-3 ">
                    <h2>24/7 HELP CENTER</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit distinctio perferendis dolorum culpa cum labore, adipisci provident, quisquam hic sequi error necessitatibus tenetur. Exercitationem illum eaque neque nesciunt ipsa ad.</p>
                    <button className="btn text-success">Learn more</button>
                </div>
                <div className="col-md-6 p-3 ">
                    <h2>FAST & FLEXIBLE</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit distinctio perferendis dolorum culpa cum labore, adipisci provident, quisquam hic sequi error necessitatibus tenetur. Exercitationem illum eaque neque nesciunt ipsa ad.</p>
                    <button className="btn text-success">Learn more</button>
                </div>
                <div className="col-md-6 p-3 ">
                    <h2>MANY CHOICE</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit distinctio perferendis dolorum culpa cum labore, adipisci provident, quisquam hic sequi error necessitatibus tenetur. Exercitationem illum eaque neque nesciunt ipsa ad.</p>
                    <button className="btn text-success">Learn more</button>
                </div>


            </div>
        </div>
    );
};

export default Features;